// extracted by mini-css-extract-plugin
module.exports = {"heading":"globalstyles_heading__2bQ1V","filter":"globalstyles_filter__3Ki_L","taggedItem":"globalstyles_taggedItem__1IgAc","buttonWrapper":"globalstyles_buttonWrapper__1Rte-"};